// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M14.3916 2C13.8287 2.86298 13.5 3.89279 13.5 5C13.5 8.03757 15.9624 10.5 19 10.5C20.1072 10.5 21.137 10.1713 22 9.6084V22H2V2H14.3916ZM8.75 16.5L16.75 12L8.75 7.5V16.5Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M20.4551 3.54395L23.6797 5L20.4551 6.45508L19 9.67969L17.5439 6.45508L14.3203 5L17.5439 3.54395L19 0.320312L20.4551 3.54395Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-ai-video-filled')
export default class AiVideoFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'ai-video-filled',
    }
  }
}
